import { useContext } from 'react';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { SmartCardContext } from '@atlaskit/link-provider';
export var isSharePointDomain = function isSharePointDomain(href) {
  try {
    var hostname = new URL(href).hostname.toLowerCase();
    return hostname.includes('sharepoint.com') || hostname.includes('onedrive.live.com');
  } catch (_unused) {
    return false;
  }
};
export var isGoogleDomain = function isGoogleDomain(href) {
  try {
    var hostname = new URL(href).hostname.toLowerCase();
    return hostname.includes('docs.google.com') || hostname.includes('drive.google.com');
  } catch (_unused2) {
    return false;
  }
};
var useResolveHyperlinkValidator = function useResolveHyperlinkValidator() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var hasSmartCardProvider = !!useContext(SmartCardContext);
  var isSharePointResolveEnabled = FeatureGates.getExperimentValue('platform_editor_resolve_hyperlinks_confluence', 'isEnabled', false) || FeatureGates.getExperimentValue('platform_editor_resolve_hyperlinks_jira', 'isEnabled', false);
  var isGoogleResolveEnabled = FeatureGates.getExperimentValue('platform_editor_resolve_google_hyperlinks', 'isEnabled', false);
  var shouldResolveSharePoint = isSharePointDomain(href) && isSharePointResolveEnabled;
  var shouldResolveGoogle = isGoogleDomain(href) && isGoogleResolveEnabled;
  return hasSmartCardProvider && (shouldResolveSharePoint || shouldResolveGoogle);
};
export default useResolveHyperlinkValidator;